// extracted by mini-css-extract-plugin
export default {"Footer":"footer_Footer__OMRYd","social_list":"footer_social_list__QqK0T"};